import { NotFound } from '@systemeio/util'
import { PAYPAL_REST_API } from 'modules/profile/payment-gateways/integrations/paypal-rest/api'
import { PaypalRestMessagesInterface } from 'modules/profile/payment-gateways/integrations/paypal-rest/types'
import { useControlledSwr } from 'shared/hooks/use-controlled-swr'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import useUser from 'shared/hooks/use-user'

export const usePaypalRestMessages = () => {
  const { user } = useUser()
  const { t } = useLocoTranslation()

  const { fetcher } = useFetch<RequestMethodsEnum.get, PaypalRestMessagesInterface>({
    method: RequestMethodsEnum.get,
    onErrorBeforeErrorHandlers: error => {
      if (error instanceof NotFound) {
        return {
          messages: [t('dashboard.settings.payment_gateways.paypal_integration_not_found')],
        }
      }
      throw error
    },
  })

  return useControlledSwr(`${PAYPAL_REST_API}/onboarding/status`, fetcher, undefined, !!user)
}
